import { render, staticRenderFns } from "./sveManagement.vue?vue&type=template&id=6e80c556&scoped=true"
import script from "./sveManagement.vue?vue&type=script&lang=js"
export * from "./sveManagement.vue?vue&type=script&lang=js"
import style0 from "./sveManagement.vue?vue&type=style&index=0&id=6e80c556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e80c556",
  null
  
)

export default component.exports